import {
  Popup,
  NumberKeyboard,
  Icon,
  Button,
  Toast,
  Swipe,
  SwipeItem,
  Lazyload,
  RadioGroup,
  Radio,
  Loading,
  Image,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup,
  Overlay,
  NoticeBar,
  Dialog,
  Field,
  Switch,
  Calendar,
  Empty,
  Skeleton,
  Card,
  Sticky,
  Tab,
  Tabs,
  Search,
} from "vant";

export default {
  install: (vue) => {
    vue.use(NumberKeyboard);
    vue.use(Popup);
    vue.use(Icon);
    vue.use(Button);
    vue.use(Toast);
    vue.use(Swipe);
    vue.use(SwipeItem);
    vue.use(Lazyload);
    vue.use(Radio);
    vue.use(RadioGroup);
    vue.use(Loading);
    vue.use(Image);
    vue.use(Cell).use(CellGroup);
    vue.use(Collapse).use(CollapseItem);
    vue.use(Overlay);
    vue.use(NoticeBar);
    vue.use(Dialog);
    vue.use(Field);
    vue.use(Switch);
    vue.use(Calendar);
    vue.use(Empty);
    vue.use(Skeleton);
    vue.use(Card);
    vue.use(Sticky);
    vue.use(Tab);
    vue.use(Tabs);
    vue.use(Search);
    vue.prototype.$loctaionUrl =
      process.env.NODE_ENV === "development"
        ? "http://api.njsimiao.com"
        : window.location.origin;
  },
};
